import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Sorteio.css';
import Images from '../../constants';

//const DB_URL = "";
const DB_URL = process.env.REACT_APP_DB_URL || process.env.API_URL || "http://localhost:10000";

function Sorteio() {
    const [numbers, setNumbers] = useState([]);
    const [newNumber, setNewNumber] = useState('');
    const [delNumber, setDelNumber] = useState('');
    const [roundId, setRoundId] = useState('');
    const [premio, setPremio] = useState('');
    const [popupRodadaAtiva, setPopupRodadaAtiva] = useState(null);
    useEffect(() => {
        if (!roundId) return;

        // Busca o estado inicial da rodada selecionada
        axios.get(`${DB_URL}/rounds/${roundId}`)
            .then(response => {
                if (response.data && response.data.numbers) {
                    setNumbers(response.data.numbers);
                }
            })
            .catch(err => {
                console.warn("Erro ao buscar dados iniciais da rodada:", err.message);
            });

        // Conecta ao fluxo de eventos SSE do servidor
        const eventSource = new EventSource(`${DB_URL}/rounds/events`);

        eventSource.onmessage = (event) => {
            try {
                const data = JSON.parse(event.data);
                if (data && data.id === roundId) {
                    setNumbers(data.numbers || []);
                }
            } catch (err) {
                console.error("Erro ao processar dados SSE no Sorteio:", err);
            }
        };

        eventSource.onerror = (err) => {
            console.error("Erro de conexão com o SSE no Sorteio:", err);
        };

        return () => {
            eventSource.close();
        };
    }, [roundId]);

    const addNumber = () => {
        if (!newNumber) return;
        const numToAdd = Number(newNumber);
        axios.put(DB_URL + '/rounds/addNumber/' + roundId, { numbers: numToAdd })
            .then(response => {
                console.log(response.data);
                setNumbers(prev => {
                    if (prev.includes(numToAdd)) return prev;
                    return [...prev, numToAdd];
                });
                setNewNumber('');
            })
            .catch(err => console.error("Erro ao adicionar número:", err));
    };

    const addNumberEnter = (KeyboardEvent) => {
        if (KeyboardEvent.key === 'Enter') {
            addNumber();
        }
    };

    const removeNumber = () => {
        if (!delNumber) return;
        const numToRemove = Number(delNumber);
        axios.put(DB_URL + '/rounds/removeNumber/' + roundId, { numbers: numToRemove })
            .then(response => {
                console.log(response.data);
                setNumbers(prev => prev.filter(num => num !== numToRemove));
                setDelNumber('');
            })
            .catch(err => console.error("Erro ao remover número:", err));
    };

    const removeNumberEnter = (KeyboardEvent) => {
        if (KeyboardEvent.key === 'Enter') {
            removeNumber();
        }
    };

    const removeSpecificNumber = (numToRemove) => {
        if (!roundId) return;
        const targetNum = Number(numToRemove);
        axios.put(DB_URL + '/rounds/removeNumber/' + roundId, { numbers: targetNum })
            .then(response => {
                console.log(response.data);
                setNumbers(prev => prev.filter(num => num !== targetNum));
            })
            .catch(err => console.error("Erro ao remover número específico:", err));
    };

    const addPrize = () => {
        axios.put(DB_URL + '/rounds/addPrize/' + roundId, { prize: premio })
            .then(response => { console.log(response.data) });
    };

    const addRound = async () => {
        try {
            const response = await axios.get(DB_URL + '/rounds/active');
            const rodadaAtiva = response.data;
            if (rodadaAtiva && rodadaAtiva.id !== roundId) {
                setPopupRodadaAtiva(rodadaAtiva.id);
                return;
            }
        } catch (err) {
            if (!err.response || err.response.status !== 404) {
                console.log(err);
                return;
            }
        }

        axios.post(DB_URL + '/rounds/addRound', { _id: roundId, id: roundId })
            .then(response => {
                console.log(response.data);
                //window.open('/Bingo', '_blank', 'width=800,height=600');
            })
            .catch(err => {
                if (err.response && err.response.status === 409) {
                    setPopupRodadaAtiva(err.response.data.activeRoundId);
                } else {
                    console.log(err);
                }
            });
    };

    const finalizarRodada = () => {
        if (!roundId) return;
        axios.put(DB_URL + '/rounds/finalize/' + roundId)
            .then(response => {
                console.log(response.data);
                setNumbers([]);
            })
            .catch(err => { console.log(err) });
    };

    return (
        <div className="login-container">
            {popupRodadaAtiva && (
                <div className="popup-overlay">
                    <div className="popup-box">
                        <p>
                            A rodada <strong>{popupRodadaAtiva}</strong> não foi finalizada.
                            Você precisa finalizá-la antes de criar uma nova rodada.
                        </p>
                        <button className="popup-button-ok" onClick={() => setPopupRodadaAtiva(null)}>
                            Entendido
                        </button>
                    </div>
                </div>
            )}

            <div className="header">
                <img src={Images[99]} alt="Logo" />
            </div>
            <div>
                {numbers.length > 0 ? numbers.slice().map((num, index) => (
                    <span key={index}><div className='ball-mini'>{num}</div></span>
                )) : <span>Sem números sorteados ainda</span>}
            </div>
            <div className="input-group">
                <input
                    type="text"
                    value={newNumber}
                    onChange={(e) => setNewNumber(e.target.value)}
                    onKeyDown={addNumberEnter}
                    placeholder="Número Sorteado"
                />
                <button className="addnumber-button" onClick={addNumber}>Adicionar Número</button>
            </div>
            <div className="input-group">
                <input
                    type="text"
                    value={roundId}
                    onChange={(e) => setRoundId(e.target.value)}
                    placeholder="Nome da Rodada"
                />
                <button className="register-button" onClick={addRound}>Adicionar Rodada</button>
                <button className="finalize-button" onClick={finalizarRodada}>Finalizar Rodada</button>
            </div>
            <div className="input-group">
                <input
                    type="text"
                    value={premio}
                    onChange={(e) => setPremio(e.target.value)}
                    placeholder="Prêmio da Rodada"
                />
                <button className="addprize-button" onClick={addPrize}>Adicionar Prêmio</button>
            </div>
            <div className="input-group">
                <input
                    type="text"
                    value={delNumber}
                    onChange={(e) => setDelNumber(e.target.value)}
                    onKeyDown={removeNumberEnter}
                    placeholder="Deletar número"
                />
                <button className="forgot-button" onClick={removeNumber}>Apagar Número</button>
            </div>
            <div className="ballsContainer">
                {numbers
                    .slice()
                    .sort((a, b) => a - b)
                    .map((num, index) => (
                        <div
                            key={index}
                            className="ball"
                            onDoubleClick={() => removeSpecificNumber(num)}>
                            {num}
                        </div>
                    ))}
            </div>
        </div>
    );
}

export default Sorteio;
